const API_BASE_URL = "https://campus-safety-app.com";
export default API_BASE_URL;